import { createFileRoute } from '@tanstack/react-router';
import SupportGuideArticle from '@pages/Support/SupportGuideArticle';

export const Route = createFileRoute('/support/support-guide-article')({
  validateSearch: (search) => ({
    slug: typeof search.slug === 'string' ? search.slug : '',
  }),
  component: SupportGuideArticle,
});
